import { ELAPSED, RELATIVE_DAY } from './constants/discoveryCopy';
import { DAYS_PER_WEEK, MINUTES_PER_HOUR, MS_PER_DAY, MS_PER_MINUTE } from './constants/units';

export const plural = (n: number, one: string, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;

const dayStart = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

export function relativeDay(iso: string, now: Date = new Date()): string {
  const then = new Date(iso);
  const days = Math.round((dayStart(now) - dayStart(then)) / MS_PER_DAY);
  if (days <= 0) return RELATIVE_DAY.today;
  if (days === 1) return RELATIVE_DAY.yesterday;
  if (days < DAYS_PER_WEEK) return RELATIVE_DAY.daysAgo(days);
  return then.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
}

export function elapsedText(iso: string, now: number): string {
  const minutes = Math.floor((now - new Date(iso).getTime()) / MS_PER_MINUTE);
  if (minutes < 1) return ELAPSED.justNow;
  if (minutes < MINUTES_PER_HOUR) return ELAPSED.minutes(minutes);
  return ELAPSED.hours(Math.floor(minutes / MINUTES_PER_HOUR), minutes % MINUTES_PER_HOUR);
}
